exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-widget-wrapper {\n  min-height: 150px;\n  border: 7px solid #55bc37;\n  border-radius: 3px;\n  background: white;\n  color: #353535;\n  padding: 14px;\n  margin: 10px 0;\n}\n", ""]);

// exports
